// extracted by mini-css-extract-plugin
export default {"title":"ConferenceAddVisitorComponent_title__EvN3i","iconEdit":"ConferenceAddVisitorComponent_iconEdit__uxLZ8","iconEdit2":"ConferenceAddVisitorComponent_iconEdit2__nNUtl"};